// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as ModalBody from "../../../../library/reuseable-components/ModalBody.bs.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ModalFooter from "../../../../library/reuseable-components/ModalFooter.bs.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as ModificationsContext from "../../../../library/modifications-context/ModificationsContext.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as CreateModificationUtils from "../../../../library/utils/CreateModificationUtils.bs.js";
import * as FormKeyInputTimeTs$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormKeyInputTimeTs.bs.js";
import * as FormSelectWithCheckboxInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectWithCheckboxInput.bs.js";

var validators_drop_zone = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var drop_zone = param.drop_zone;
      if (drop_zone) {
        return {
                TAG: /* Ok */0,
                _0: List.map(Caml_format.caml_int_of_string, drop_zone)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_drop_cluster = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var drop_cluster = param.drop_cluster;
      if (drop_cluster) {
        return {
                TAG: /* Ok */0,
                _0: List.map(Caml_format.caml_int_of_string, drop_cluster)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_pickup_zone = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var pickup_zone = param.pickup_zone;
      if (pickup_zone) {
        return {
                TAG: /* Ok */0,
                _0: List.map(Caml_format.caml_int_of_string, pickup_zone)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_pickup_cluster = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var pickup_cluster = param.pickup_cluster;
      if (pickup_cluster) {
        return {
                TAG: /* Ok */0,
                _0: List.map(Caml_format.caml_int_of_string, pickup_cluster)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_days = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var days = param.days;
      if (days) {
        return {
                TAG: /* Ok */0,
                _0: days
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: List.map((function (d) {
                        return d.value;
                      }), CreateModificationUtils.RepeatDays.daysOptions)
              };
      }
    })
};

var validators_end_time = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var end_time = param.end_time;
      if (end_time === undefined) {
        return {
                TAG: /* Error */1,
                _0: "A vaild time is required"
              };
      }
      var start_time = param.start_time;
      if (start_time === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter start time first."
              };
      }
      var end_time$1 = Caml_option.valFromOption(end_time);
      if (Timestamp$Catalyst.isBefore(end_time$1, Caml_option.valFromOption(start_time))) {
        return {
                TAG: /* Error */1,
                _0: "Start time cannot be greater than end time"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: end_time$1
              };
      }
    })
};

var validators_start_time = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var start_time = param.start_time;
      if (start_time !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.valFromOption(start_time)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "A vaild time is required"
              };
      }
    })
};

var validators = {
  drop_zone: validators_drop_zone,
  drop_cluster: validators_drop_cluster,
  pickup_zone: validators_pickup_zone,
  pickup_cluster: validators_pickup_cluster,
  days: validators_days,
  end_time: validators_end_time,
  start_time: validators_start_time
};

function initialFieldsStatuses(_input) {
  return {
          drop_zone: /* Pristine */0,
          drop_cluster: /* Pristine */0,
          pickup_zone: /* Pristine */0,
          pickup_cluster: /* Pristine */0,
          days: /* Pristine */0,
          end_time: /* Pristine */0,
          start_time: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.drop_zone;
  var match_0 = match ? match._0 : Curry._1(validators.drop_zone.validate, input);
  var match$1 = fieldsStatuses.drop_cluster;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.drop_cluster.validate, input);
  var match$2 = fieldsStatuses.pickup_zone;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.pickup_zone.validate, input);
  var match$3 = fieldsStatuses.pickup_cluster;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.pickup_cluster.validate, input);
  var match$4 = fieldsStatuses.days;
  var match_0$4 = match$4 ? match$4._0 : Curry._1(validators.days.validate, input);
  var match$5 = fieldsStatuses.end_time;
  var match_0$5 = match$5 ? match$5._0 : Curry._1(validators.end_time.validate, input);
  var match$6 = fieldsStatuses.start_time;
  var match_0$6 = match$6 ? match$6._0 : Curry._1(validators.start_time.validate, input);
  var drop_zoneResult = match_0;
  var drop_zoneResult$1;
  if (drop_zoneResult.TAG === /* Ok */0) {
    var drop_clusterResult = match_0$1;
    if (drop_clusterResult.TAG === /* Ok */0) {
      var pickup_zoneResult = match_0$2;
      if (pickup_zoneResult.TAG === /* Ok */0) {
        var pickup_clusterResult = match_0$3;
        if (pickup_clusterResult.TAG === /* Ok */0) {
          var daysResult = match_0$4;
          if (daysResult.TAG === /* Ok */0) {
            var end_timeResult = match_0$5;
            if (end_timeResult.TAG === /* Ok */0) {
              var start_timeResult = match_0$6;
              if (start_timeResult.TAG === /* Ok */0) {
                return {
                        TAG: /* Valid */0,
                        output: {
                          start_time: start_timeResult._0,
                          end_time: end_timeResult._0,
                          days: daysResult._0,
                          pickup_cluster: pickup_clusterResult._0,
                          pickup_zone: pickup_zoneResult._0,
                          drop_cluster: drop_clusterResult._0,
                          drop_zone: drop_zoneResult._0
                        },
                        fieldsStatuses: {
                          drop_zone: /* Dirty */{
                            _0: drop_zoneResult,
                            _1: /* Shown */0
                          },
                          drop_cluster: /* Dirty */{
                            _0: drop_clusterResult,
                            _1: /* Shown */0
                          },
                          pickup_zone: /* Dirty */{
                            _0: pickup_zoneResult,
                            _1: /* Shown */0
                          },
                          pickup_cluster: /* Dirty */{
                            _0: pickup_clusterResult,
                            _1: /* Shown */0
                          },
                          days: /* Dirty */{
                            _0: daysResult,
                            _1: /* Shown */0
                          },
                          end_time: /* Dirty */{
                            _0: end_timeResult,
                            _1: /* Shown */0
                          },
                          start_time: /* Dirty */{
                            _0: start_timeResult,
                            _1: /* Shown */0
                          }
                        },
                        collectionsStatuses: undefined
                      };
              }
              drop_zoneResult$1 = drop_zoneResult;
            } else {
              drop_zoneResult$1 = drop_zoneResult;
            }
          } else {
            drop_zoneResult$1 = drop_zoneResult;
          }
        } else {
          drop_zoneResult$1 = drop_zoneResult;
        }
      } else {
        drop_zoneResult$1 = drop_zoneResult;
      }
    } else {
      drop_zoneResult$1 = drop_zoneResult;
    }
  } else {
    drop_zoneResult$1 = drop_zoneResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            drop_zone: /* Dirty */{
              _0: drop_zoneResult$1,
              _1: /* Shown */0
            },
            drop_cluster: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            pickup_zone: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            pickup_cluster: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            days: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            end_time: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            start_time: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurDrop_zoneField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.drop_zone, validators_drop_zone, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  drop_zone: status,
                                  drop_cluster: init.drop_cluster,
                                  pickup_zone: init.pickup_zone,
                                  pickup_cluster: init.pickup_cluster,
                                  days: init.days,
                                  end_time: init.end_time,
                                  start_time: init.start_time
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDrop_clusterField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.drop_cluster, validators_drop_cluster, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  drop_zone: init.drop_zone,
                                  drop_cluster: status,
                                  pickup_zone: init.pickup_zone,
                                  pickup_cluster: init.pickup_cluster,
                                  days: init.days,
                                  end_time: init.end_time,
                                  start_time: init.start_time
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPickup_zoneField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.pickup_zone, validators_pickup_zone, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  drop_zone: init.drop_zone,
                                  drop_cluster: init.drop_cluster,
                                  pickup_zone: status,
                                  pickup_cluster: init.pickup_cluster,
                                  days: init.days,
                                  end_time: init.end_time,
                                  start_time: init.start_time
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPickup_clusterField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.pickup_cluster, validators_pickup_cluster, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  drop_zone: init.drop_zone,
                                  drop_cluster: init.drop_cluster,
                                  pickup_zone: init.pickup_zone,
                                  pickup_cluster: status,
                                  days: init.days,
                                  end_time: init.end_time,
                                  start_time: init.start_time
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDaysField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.days, validators_days, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  drop_zone: init.drop_zone,
                                  drop_cluster: init.drop_cluster,
                                  pickup_zone: init.pickup_zone,
                                  pickup_cluster: init.pickup_cluster,
                                  days: status,
                                  end_time: init.end_time,
                                  start_time: init.start_time
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEnd_timeField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.end_time, validators_end_time, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  drop_zone: init.drop_zone,
                                  drop_cluster: init.drop_cluster,
                                  pickup_zone: init.pickup_zone,
                                  pickup_cluster: init.pickup_cluster,
                                  days: init.days,
                                  end_time: status,
                                  start_time: init.start_time
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStart_timeField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.start_time, validators_start_time, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  drop_zone: init.drop_zone,
                                  drop_cluster: init.drop_cluster,
                                  pickup_zone: init.pickup_zone,
                                  pickup_cluster: init.pickup_cluster,
                                  days: init.days,
                                  end_time: init.end_time,
                                  start_time: status
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */7 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */7,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */8,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */10);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */9);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */8 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */9 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */10 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateDrop_zoneField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.drop_zone, state.submissionStatus, validators_drop_zone, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            drop_zone: status,
                                            drop_cluster: init.drop_cluster,
                                            pickup_zone: init.pickup_zone,
                                            pickup_cluster: init.pickup_cluster,
                                            days: init.days,
                                            end_time: init.end_time,
                                            start_time: init.start_time
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDrop_clusterField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.drop_cluster, state.submissionStatus, validators_drop_cluster, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            drop_zone: init.drop_zone,
                                            drop_cluster: status,
                                            pickup_zone: init.pickup_zone,
                                            pickup_cluster: init.pickup_cluster,
                                            days: init.days,
                                            end_time: init.end_time,
                                            start_time: init.start_time
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePickup_zoneField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.pickup_zone, state.submissionStatus, validators_pickup_zone, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            drop_zone: init.drop_zone,
                                            drop_cluster: init.drop_cluster,
                                            pickup_zone: status,
                                            pickup_cluster: init.pickup_cluster,
                                            days: init.days,
                                            end_time: init.end_time,
                                            start_time: init.start_time
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePickup_clusterField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.pickup_cluster, state.submissionStatus, validators_pickup_cluster, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            drop_zone: init.drop_zone,
                                            drop_cluster: init.drop_cluster,
                                            pickup_zone: init.pickup_zone,
                                            pickup_cluster: status,
                                            days: init.days,
                                            end_time: init.end_time,
                                            start_time: init.start_time
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDaysField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.days, state.submissionStatus, validators_days, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            drop_zone: init.drop_zone,
                                            drop_cluster: init.drop_cluster,
                                            pickup_zone: init.pickup_zone,
                                            pickup_cluster: init.pickup_cluster,
                                            days: status,
                                            end_time: init.end_time,
                                            start_time: init.start_time
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEnd_timeField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$5, state.fieldsStatuses.end_time, state.submissionStatus, validators_end_time, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            drop_zone: init.drop_zone,
                                            drop_cluster: init.drop_cluster,
                                            pickup_zone: init.pickup_zone,
                                            pickup_cluster: init.pickup_cluster,
                                            days: init.days,
                                            end_time: status,
                                            start_time: init.start_time
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStart_timeField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$7 = Formality.validateDependentFieldOnChange(nextInput$6, nextFieldsStatuses.contents.end_time, validators_end_time, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  drop_zone: init.drop_zone,
                                  drop_cluster: init.drop_cluster,
                                  pickup_zone: init.pickup_zone,
                                  pickup_cluster: init.pickup_cluster,
                                  days: init.days,
                                  end_time: status,
                                  start_time: init.start_time
                                };
                        }));
                  if (result$7 !== undefined) {
                    nextFieldsStatuses.contents = result$7;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$6, nextFieldsStatuses.contents.start_time, state.submissionStatus, validators_start_time, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            drop_zone: init.drop_zone,
                                            drop_cluster: init.drop_cluster,
                                            pickup_zone: init.pickup_zone,
                                            pickup_cluster: init.pickup_cluster,
                                            days: init.days,
                                            end_time: init.end_time,
                                            start_time: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */7 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */8 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */9 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateDrop_zone: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDrop_zoneField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDrop_cluster: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDrop_clusterField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePickup_zone: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePickup_zoneField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePickup_cluster: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePickup_clusterField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDays: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDaysField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEnd_time: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEnd_timeField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStart_time: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStart_timeField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurDrop_zone: (function (param) {
              return Curry._1(dispatch, /* BlurDrop_zoneField */0);
            }),
          blurDrop_cluster: (function (param) {
              return Curry._1(dispatch, /* BlurDrop_clusterField */1);
            }),
          blurPickup_zone: (function (param) {
              return Curry._1(dispatch, /* BlurPickup_zoneField */2);
            }),
          blurPickup_cluster: (function (param) {
              return Curry._1(dispatch, /* BlurPickup_clusterField */3);
            }),
          blurDays: (function (param) {
              return Curry._1(dispatch, /* BlurDaysField */4);
            }),
          blurEnd_time: (function (param) {
              return Curry._1(dispatch, /* BlurEnd_timeField */5);
            }),
          blurStart_time: (function (param) {
              return Curry._1(dispatch, /* BlurStart_timeField */6);
            }),
          drop_zoneResult: Formality.exposeFieldResult(state.fieldsStatuses.drop_zone),
          drop_clusterResult: Formality.exposeFieldResult(state.fieldsStatuses.drop_cluster),
          pickup_zoneResult: Formality.exposeFieldResult(state.fieldsStatuses.pickup_zone),
          pickup_clusterResult: Formality.exposeFieldResult(state.fieldsStatuses.pickup_cluster),
          daysResult: Formality.exposeFieldResult(state.fieldsStatuses.days),
          end_timeResult: Formality.exposeFieldResult(state.fieldsStatuses.end_time),
          start_timeResult: Formality.exposeFieldResult(state.fieldsStatuses.start_time),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.drop_zone || match.drop_cluster || match.pickup_zone || match.pickup_cluster || match.days || match.end_time || match.start_time) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */7);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */8);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */9);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */9,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */10);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialInput(eligiblity_rules, clusters, zones) {
  if (eligiblity_rules === undefined) {
    return {
            start_time: undefined,
            end_time: undefined,
            days: /* [] */0,
            pickup_cluster: /* [] */0,
            pickup_zone: /* [] */0,
            drop_cluster: /* [] */0,
            drop_zone: /* [] */0
          };
  }
  var c = eligiblity_rules.pickup_cluster;
  var c$1 = eligiblity_rules.pickup_zone;
  var c$2 = eligiblity_rules.drop_cluster;
  var c$3 = eligiblity_rules.drop_zone;
  return {
          start_time: Caml_option.some(eligiblity_rules.start_time),
          end_time: Caml_option.some(eligiblity_rules.end_time),
          days: eligiblity_rules.days,
          pickup_cluster: c !== undefined ? List.map((function (a) {
                    return String(a.id);
                  }), List.filter(function (a) {
                        return List.exists((function (v) {
                                      return v === a.id;
                                    }), c);
                      })(clusters)) : /* [] */0,
          pickup_zone: c$1 !== undefined ? List.map((function (a) {
                    return String(a.id);
                  }), List.filter(function (a) {
                        return List.exists((function (v) {
                                      return v === a.id;
                                    }), c$1);
                      })(zones)) : /* [] */0,
          drop_cluster: c$2 !== undefined ? List.map((function (a) {
                    return String(a.id);
                  }), List.filter(function (a) {
                        return List.exists((function (v) {
                                      return v === a.id;
                                    }), c$2);
                      })(clusters)) : /* [] */0,
          drop_zone: c$3 !== undefined ? List.map((function (a) {
                    return String(a.id);
                  }), List.filter(function (a) {
                        return List.exists((function (v) {
                                      return v === a.id;
                                    }), c$3);
                      })(zones)) : /* [] */0
        };
}

function SimpleEligibilityRulesForm(Props) {
  var eligiblity_rules = Props.eligiblity_rules;
  var onNext = Props.onNext;
  var onBack = Props.onBack;
  var match = ModificationsContext.useContext(undefined);
  var clusters = match.clusters;
  var zones = match.zones;
  var form = useForm(getInitialInput(eligiblity_rules, clusters, zones), (function (output, submissionCbs) {
          Curry._1(onNext, {
                start_time: output.start_time,
                end_time: output.end_time,
                days: output.days,
                pickup_cluster: output.pickup_cluster,
                pickup_zone: output.pickup_zone,
                drop_cluster: output.drop_cluster,
                drop_zone: output.drop_zone
              });
          return Curry._1(submissionCbs.notifyOnSuccess, undefined);
        }));
  return React.createElement(React.Fragment, undefined, React.createElement(ModalBody.make, {
                  className: "c-key-details-form",
                  children: null
                }, React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Start Time"), React.createElement(FormKeyInputTimeTs$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (param) {
                                  
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.start_timeResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Enter time in 24 Hour format (HH:MM)"
                              }, undefined, undefined, undefined, undefined, undefined),
                          time_props: {
                            value: form.input.start_time,
                            onChange: (function (date) {
                                return Curry._2(form.updateStart_time, (function (input, value) {
                                              return {
                                                      start_time: value,
                                                      end_time: input.end_time,
                                                      days: input.days,
                                                      pickup_cluster: input.pickup_cluster,
                                                      pickup_zone: input.pickup_zone,
                                                      drop_cluster: input.drop_cluster,
                                                      drop_zone: input.drop_zone
                                                    };
                                            }), date);
                              }),
                            format: "HH:mm",
                            ampm: false,
                            isDisabled: false
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "End Time"), React.createElement(FormKeyInputTimeTs$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (param) {
                                  
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.end_timeResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Enter time in 24 Hour format (HH:MM)"
                              }, undefined, undefined, undefined, undefined, undefined),
                          time_props: {
                            value: form.input.end_time,
                            onChange: (function (date) {
                                return Curry._2(form.updateEnd_time, (function (input, value) {
                                              return {
                                                      start_time: input.start_time,
                                                      end_time: value,
                                                      days: input.days,
                                                      pickup_cluster: input.pickup_cluster,
                                                      pickup_zone: input.pickup_zone,
                                                      drop_cluster: input.drop_cluster,
                                                      drop_zone: input.drop_zone
                                                    };
                                            }), date);
                              }),
                            format: "HH:mm",
                            ampm: false,
                            isDisabled: false
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Repeat On Day(s)"), React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateDays, (function (input, value) {
                                                return {
                                                        start_time: input.start_time,
                                                        end_time: input.end_time,
                                                        days: value,
                                                        pickup_cluster: input.pickup_cluster,
                                                        pickup_zone: input.pickup_zone,
                                                        drop_cluster: input.drop_cluster,
                                                        drop_zone: input.drop_zone
                                                      };
                                              }), FormHelper$Catalyst.TargetListEventWrapper.listValue($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.daysResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Select Days to Repeat"
                              }, undefined, undefined, undefined, undefined, undefined),
                          select_props: {
                            selected: form.input.days,
                            options: CreateModificationUtils.RepeatDays.daysOptions,
                            renderValue: undefined
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Pickup Cluster(s)"), React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updatePickup_cluster, (function (input, value) {
                                                return {
                                                        start_time: input.start_time,
                                                        end_time: input.end_time,
                                                        days: input.days,
                                                        pickup_cluster: value,
                                                        pickup_zone: input.pickup_zone,
                                                        drop_cluster: input.drop_cluster,
                                                        drop_zone: input.drop_zone
                                                      };
                                              }), FormHelper$Catalyst.TargetListEventWrapper.listValue($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.pickup_clusterResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Select All / Multiple Clusters"
                              }, undefined, undefined, undefined, undefined, undefined),
                          select_props: {
                            selected: form.input.pickup_cluster,
                            options: CreateModificationUtils.ClusterUtils.clustersToCheckBoxItems(clusters),
                            renderValue: (function (values) {
                                return CreateModificationUtils.ClusterUtils.getClusterSelectDisplayData(values, clusters);
                              })
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Pickup Zone(s)"), React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updatePickup_zone, (function (input, value) {
                                                return {
                                                        start_time: input.start_time,
                                                        end_time: input.end_time,
                                                        days: input.days,
                                                        pickup_cluster: input.pickup_cluster,
                                                        pickup_zone: value,
                                                        drop_cluster: input.drop_cluster,
                                                        drop_zone: input.drop_zone
                                                      };
                                              }), FormHelper$Catalyst.TargetListEventWrapper.listValue($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.pickup_zoneResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Select All / Multiple Zones"
                              }, undefined, undefined, undefined, undefined, undefined),
                          select_props: {
                            selected: form.input.pickup_zone,
                            options: CreateModificationUtils.ZoneUtils.zonesToCheckBoxItems(zones),
                            renderValue: (function (values) {
                                return CreateModificationUtils.ZoneUtils.getZoneSelectDisplayData(values, zones);
                              })
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Drop Cluster(s)"), React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateDrop_cluster, (function (input, value) {
                                                return {
                                                        start_time: input.start_time,
                                                        end_time: input.end_time,
                                                        days: input.days,
                                                        pickup_cluster: input.pickup_cluster,
                                                        pickup_zone: input.pickup_zone,
                                                        drop_cluster: value,
                                                        drop_zone: input.drop_zone
                                                      };
                                              }), FormHelper$Catalyst.TargetListEventWrapper.listValue($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.drop_clusterResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Select All / Multiple Clusters"
                              }, undefined, undefined, undefined, undefined, undefined),
                          select_props: {
                            selected: form.input.drop_cluster,
                            options: CreateModificationUtils.ClusterUtils.clustersToCheckBoxItems(clusters),
                            renderValue: (function (values) {
                                return CreateModificationUtils.ClusterUtils.getClusterSelectDisplayData(values, clusters);
                              })
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Drop Zone(s)"), React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateDrop_zone, (function (input, value) {
                                                return {
                                                        start_time: input.start_time,
                                                        end_time: input.end_time,
                                                        days: input.days,
                                                        pickup_cluster: input.pickup_cluster,
                                                        pickup_zone: input.pickup_zone,
                                                        drop_cluster: input.drop_cluster,
                                                        drop_zone: value
                                                      };
                                              }), FormHelper$Catalyst.TargetListEventWrapper.listValue($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.drop_zoneResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Select All / Multiple Zones"
                              }, undefined, undefined, undefined, undefined, undefined),
                          select_props: {
                            selected: form.input.drop_zone,
                            options: CreateModificationUtils.ZoneUtils.zonesToCheckBoxItems(zones),
                            renderValue: (function (values) {
                                return CreateModificationUtils.ZoneUtils.getZoneSelectDisplayData(values, zones);
                              })
                          }
                        }))), React.createElement(ModalFooter.make, {
                  children: null
                }, React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Previous"
                          }, undefined, (function (param) {
                              return Curry._1(onBack, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined)
                    }), React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Preview"
                          }, undefined, (function (param) {
                              return Curry._1(form.submit, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined)
                    })));
}

var make = SimpleEligibilityRulesForm;

export {
  Form ,
  getInitialInput ,
  make ,
  
}
/* react Not a pure module */
